
import React from 'react';
import { ExternalLink } from 'lucide-react';

interface VideoThumbnailProps {
  image: string;
  title: string;
  videoId?: string;
  onVideoClick: () => void;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  image,
  title,
  videoId,
  onVideoClick,
}) => {
  return (
    <div className="relative">
      <div 
        className="aspect-video w-full bg-gray-100 dark:bg-gray-800 cursor-pointer" 
        onClick={onVideoClick}
      >
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        
        {/* YouTube play button overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-red-600 rounded-full w-12 h-12 flex items-center justify-center">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 24 24" 
              fill="white" 
              className="w-6 h-6"
              style={{ marginLeft: "2px" }}
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        
        {/* Video controls overlay at bottom */}
        <div className="absolute bottom-4 left-4 right-4 flex justify-between">
          <button className="bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded flex items-center">
            <span className="mr-1">À regarder...</span>
          </button>
          <button className="bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
            Partager
          </button>
        </div>
      </div>
      
      {/* External link icon */}
      {videoId && (
        <a 
          href={`https://www.youtube.com/watch?v=${videoId}`}
          target="_blank" 
          rel="noopener noreferrer"
          className="absolute top-2 right-2 bg-black bg-opacity-50 rounded-full p-1.5 text-white hover:bg-opacity-70 transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          <ExternalLink className="h-4 w-4" />
        </a>
      )}
    </div>
  );
};

export default VideoThumbnail;
